// Icon made by[author link]from www.flaticon.com
import React, { Component } from 'react'

export default class Footer extends Component {
    render() {
        return (
            <div className="footer">
            </div>
        )
    }
}